import { CashflowChart } from '../../core/entities/general/CashflowChart.entity';
import { CashflowInterfaceResponse } from '../interfaces/cashflow-trace.interface';

export class CashflowTraceMapper {
  static fromResponseToEntity(
    response: CashflowInterfaceResponse
  ): CashflowChart {
    return new CashflowChart(
      response.totalCashflow,
      response.totalIncome,
      response.totalExpense,
      response.historical
    );
  }
}
